import { AnyAction } from 'redux';
import {
  ORDER_RECEIVE,
  ORDER_ERROR,
  ORDER_CHANGE_MODE,
  ORDER_CHANGE_CURRENTPAGE,
  ORDER_SET_ORDER,
  ViewMode,
  ORDER_SET_IS_LOADING,
} from '../constants';
import { Order } from '../Types/Order';
import { error as errorReducer } from './Error.reducer';

export interface ORDER_STATE {
  mode: ViewMode;
  list: Order[];
  order?: Order;
  totalCount: number;
  showOnlyMyOrders: boolean;
  errors: any;
  isLoading: boolean;
}

export const DEFAULT_STATE: ORDER_STATE = {
  mode: ViewMode.List,
  list: [],
  totalCount: 0,
  showOnlyMyOrders: false,
  errors: {},
  isLoading: false,
};

export const order = (
  state = DEFAULT_STATE,
  action: AnyAction
): ORDER_STATE => {
  const { type, payload } = action;
  switch (type) {
    case ORDER_RECEIVE:
    case ORDER_CHANGE_MODE:
    case ORDER_CHANGE_CURRENTPAGE:
    case ORDER_SET_ORDER:
    case ORDER_SET_IS_LOADING:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case ORDER_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
